<div class="bg-white" [ngClass]="this.srvRpDesign.getResponsiveClass('mx-3 my-5', 'm-3')" *ngIf="externalSettings">

    <div class="d-flex justify-content-center">
        <div [ngStyle]="UIUtilityService.getHeaderStyle()">
            <span class="font-dialog-confirm-title">{{ "SESSION_DIALOG.TITLE" | translate }}</span>
        </div>
    </div>

    <div class="item-center" [ngClass]="this.srvRpDesign.getResponsiveClass('py-5', 'py-4')">
        <mat-icon svgIcon="falCheckCircle" class="icon-center" [ngClass]="this.srvRpDesign.getResponsiveClass('icon-size-30', 'icon-size-20')" [ngStyle]="UIUtilityService.getWarningIconStyle()"></mat-icon>
    </div>

    <div class="mb-3 font-dialog-confirm-content">
        <div class="text-center">
            <span>{{ "SESSION_DIALOG.MESSAGE_1" | translate}}</span>
            <span class="font-dialog-confirm-content-emphasis">{{ this.remainingTime }}</span>
            <span>{{ "SESSION_DIALOG.MESSAGE_2" | translate}}</span>
            <br />
            <span> {{ "SESSION_DIALOG.MESSAGE_3" | translate}}</span>
        </div>
    </div>

    <div class="d-flex" [ngClass]="this.srvRpDesign.getDialogButtonsPadClass()">

        <button class="p-4 me-3 font-button button-action-cancel" mat-button (click)="cancel($event)">
            {{ "SESSION_DIALOG.BUTTON_NO" | translate }}
        </button>

        <button class="p-4 mx-0 font-button button-action-base" mat-button (click)="confirm($event)" cdkFocusInitial>
            {{ "SESSION_DIALOG.BUTTON_YES" | translate }}
        </button>

    </div>

</div>